/** @format */
import { css } from 'styled-components';

const baseStyles = () => {
    const linkPadding = '0.8rem';

    /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    return css`
        .heading {
            margin: 0;
        }

        .link-wrapper {
            margin: -${linkPadding};
            border-radius: 0.8rem;
            width: calc(100% - ${linkPadding});
        }

        .link-container {
            padding: ${linkPadding};

            display: flex;
            align-items: center;
            gap: 0.8rem;
            width: 100%;

            &:hover {
                svg {
                    fill: var(--colors-text-accent);
                }
            }
        }

        .chevron {
            width: 1.6rem;
            fill: var(--colors-text-secondary);
        }
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
